import { UserHelper } from '@unifyapps/carbon/helpers/UserHelper';
import type { CurrentUserDetails } from '@unifyapps/network/generated/models/currentUserDetails';

export function getLocaleToUse(user: CurrentUserDetails, locale?: string) {
  return locale ?? UserHelper.getLocale(user);
}
